<app-header [pages]=pages></app-header>
<!-- <app-section [pages]=pages></app-section> -->
<!-- <article *ngIf="pages.length==0">
	<h1>Cargando...</h1>
</article> -->
<div class="loading-block" *ngIf="!pages">
  <div class="progress-bar-load blue"></div>
  <div class="progress-bar-load"></div>
</div>
<article *ngFor="let page of pages">
		<div class="row">
			<div class="col-md-3 offset-md-1 info col-xm-12">
        <!-- <h1><span>{{page.title}}</span></h1> -->
				<!-- <h2 [innerHTML]={{parent}}></h2>  -->
        <!-- <h2>{{page.id}}</h2> -->
				<!-- <ul class="filters">
					<li class="active">All</li>
					<li>Audio</li>
					<li>Video</li>
					<li>Imágen</li>
				</ul> -->
        <app-menu-childs *ngIf="page.parent==0 && page.slug!='texto-legal' && page.slug!='lege-oharra'" [parent_id]="page.id" [parent_link]="page.link" [parent_title]="page.title"></app-menu-childs>
        <app-menu-childs *ngIf="page.parent>0 && page.slug!='texto-legal' && page.slug!='lege-oharra'" [parent_id]="page.parent" [parent_title]="page.parent_title" [parent_link]="page.parent_link"></app-menu-childs>
        <!-- imagenes en lista-->
      </div>
			<div class="col-md-7 col-xm-12">
				<section>
				<div class="row" *ngIf="page.content">
					<div class="col-md-12">
						<!-- <app-menu-childs *ngIf="page.parent>0" [parent_id]="page.id" [parent_link]="page.link"></app-menu-childs> -->
						<div class="article-content" [innerHTML]="page.content"></div>
						<!-- <div>
							Contenido de los hijos
						</div> -->
					</div>
				</div>
			</section>
				<section class="page-gallery" *ngIf="page.gallery.length>0 && page.gallery[0]">
					<h2 i18n>Galería fotográfica</h2>
  				<ks-modal-gallery [id]="0" [slideConfig]="{infinite: true, sidePreviews: {show: false}}" [buttonsConfig]="buttonsConfigIndustria" [previewConfig]="{visible: false}" [dotsConfig]="{visible: false}" [currentImageConfig]="{downloadable: true, description: {imageText:''}}" [modalImages]="page.gallery" [plainGalleryConfig]="customPlainGalleryRowDescConfig"></ks-modal-gallery>
				</section>
				<section class="section-publitas">
					<div class="row" *ngIf="page.pdf">
            <div *ngIf="page.parent!=49" class="title-pdf"><span i18n>Sección referente a <strong>{{page.title}}</strong> en la publicación <strong>{{page.pdf.title}}</strong></span></div>

						<div class="col-md-12">
              <!-- <div><h3>{{page.pdf.title}}</h3></div> -->
							<simple-pdf-viewer #pdfViewer [src]="page.pdf.url" [removePageBorders]="true" (onProgress)="onProgressPDF($event,page.pdf.filesize)"></simple-pdf-viewer>
							<div class="pdf-buttons" *ngIf="!pdfViewer.isDocumentLoaded()">
								<button><span i18n>Cargando documento</span> {{loaderPDF}}%</button>
							</div>
							<div class="pdf-buttons" style="" *ngIf="pdfViewer.isDocumentLoaded()">
								<button (click)="pdfViewer.firstPage()" i18n>Primera página</button>
								<button (click)="pdfViewer.prevPage()" i18n>Anterior</button>
								<button>{{pdfViewer.getCurrentPage()}}/{{pdfViewer.getNumberOfPages()}}</button>
								<button (click)="pdfViewer.nextPage()" i18n>Siguiente</button>
								<button (click)="pdfViewer.lastPage()" i18n>Última página</button>
                <button (click)="windowOpen(page.pdf.url)" i18n>Descarga</button>
							</div>
							<div class="pdf-buttons pdf-buttons-bottom" style="" *ngIf="pdfViewer.isDocumentLoaded()">
								<button (click)="pdfViewer.firstPage()" i18n>Primera página</button>
								<button (click)="pdfViewer.prevPage()" i18n>Anterior</button>
								<button>{{pdfViewer.getCurrentPage()}}/{{pdfViewer.getNumberOfPages()}}</button>
								<button (click)="pdfViewer.nextPage()" i18n>Siguiente</button>
								<button (click)="pdfViewer.lastPage()" i18n>Última página</button>
                <button (click)="windowOpen(page.pdf.url)" i18n>Descarga</button>
							</div>
						</div>
					</div>
				</section>
			</div>
			<!-- <div class="col-md-7">{{page.content}}</div> -->
		</div>
  </article>
